import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/twitter.vue
var o = {
	name: "DtIconTwitter",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--twitter"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Twitter",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		d: "M8.66 19.626c6.793 0 10.508-5.628 10.508-10.508 0-.16 0-.319-.01-.477A7.513 7.513 0 0 0 21 6.729a7.372 7.372 0 0 1-2.121.581 3.706 3.706 0 0 0 1.623-2.042 7.4 7.4 0 0 1-2.345.896 3.696 3.696 0 0 0-6.293 3.368 10.485 10.485 0 0 1-7.611-3.858 3.696 3.696 0 0 0 1.143 4.93 3.665 3.665 0 0 1-1.676-.463v.047a3.695 3.695 0 0 0 2.963 3.62 3.687 3.687 0 0 1-1.668.064 3.697 3.697 0 0 0 3.45 2.564A7.41 7.41 0 0 1 3 17.967a10.456 10.456 0 0 0 5.66 1.656",
		fill: "#1DA1F2"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=twitter.js.map